<template>
  <v-layout style="padding-bottom: 30px" row wrap>
    <v-flex sm12>
      <v-layout pl-2 row wrap align-center v-for="(item,index) in OrderCodes" :key="index">
        <h-currency-input
          label="Giá trị thanh toán"
          :decimal="2" 
          v-model="item.Amount"
          class="input-group--focused mx-1 px-0"
          @change="updateOrderCode"
          :readonly="locked"
        ></h-currency-input>
        <v-layout row>
          <div class="wrapper-copy">
            <v-text-field
              label="Mã đơn TQ"
              v-model="item.OrderCode"
              class="input-group--focused mx-1 px-0"
              @change="updateOrderCode"
              :readonly="locked"
            ></v-text-field>
            <v-btn title="copy" class="copy-btn" icon @click="copyText">
                <v-icon>fa-copy</v-icon>
            </v-btn>
          </div>
        </v-layout>
        <v-layout row>
          <div class="wrapper-copy">
            <v-select
              label="Tài khoản ủy quyền"
              style="margin-right: 15px;"
              :items="payAccounts"
              v-model="item.PayID"
              @change="updateOrderCode"
              item-text="name" item-value="value"
              :readonly="locked && !canConfirm"
            ></v-select>
            <v-btn title="copy" class="copy-btn" icon @click="copyText">
                  <v-icon>fa-copy</v-icon>
            </v-btn>
          </div>
        </v-layout>
        <v-layout row>
          <div class="wrapper-copy">
            <v-text-field
              label="Link thanh toán"
              v-model="item.LinkPay"
              @change="updateOrderCode"
              class="input-group--focused mx-1 px-0"
              :readonly="locked && !canConfirm"
            ></v-text-field>
            <v-btn title="copy" class="copy-btn" icon @click="copyText">
                  <v-icon>fa-copy</v-icon>
            </v-btn>
          </div>
        </v-layout>
        <v-text-field
          label="Trạng thái"
          :value="item.Cancelled ? 'Đã hủy' : mainStatus"
          class="input-group--focused mx-1 px-0"
          readonly
        ></v-text-field>
        <v-flex pt-0 mt-0>
          <v-textarea :readonly="locked" v-model="item.Note" background-color="#fefefe" dense rows="2" outlined label="Ghi chú"></v-textarea>
        </v-flex>
        <v-btn icon @click="value.splice(index, 1); updateOrderCode();" :disabled="locked">
          <v-icon>fa-trash-alt</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
    <v-btn absolute bottom right icon @click="addOrderCode()" class="ml-5" :disabled="locked">
      <v-icon color="#dc3545">far fa-plus-square</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
import configs from "@/configs";
import _ from "lodash";

export default {
  name: "authority-executes",
  props: {
    value: Array,
    orderType: Number,
    orderId: Number,
    orderStatus: Number,
    locked: {
      type: Boolean,
      default: true
    },
    canConfirm: {
      type: Boolean,
      default: false
    },
    payAccounts: Array,
  },
  data() {
    return {
      OrderCodes: this.value,
    };
  },
  watch: {
    value() {
      this.OrderCodes = this.value;
    }
  },
  methods: {
    copyText(event) {
        const el = event.target.parentElement.closest('.row').querySelector('.v-select__selection');
        if(el) {
          var range = document.createRange();
          range.selectNode(el);
          window.getSelection().removeAllRanges(); // clear current selection
          window.getSelection().addRange(range); // to select text
          document.execCommand("copy");
          window.getSelection().removeAllRanges();// to deselect
        }
        else { 
          const el = event.target.parentElement.closest('.row').querySelector('input');
          if (el) {
              el.select();
              document.execCommand("copy");
          }
        }        
    },
    addOrderCode() {
      this.OrderCodes.push({
        Amount: 0,
        OrderCode: '',
        PayID: 0,
        LinkPay: '',
        Note: '',
        ParentID: this.orderId
      })
    },
    updateOrderCode() {
      this.$emit('input', this.OrderCodes)
    }
  },
  computed: {
    mainStatus() {
      const status = configs.PAY_AUTHORITY_STATUS.find(s => s.value == this.orderStatus);
      if (status) return status.name;
      return '';
    }
  },
  mounted() {
  }
};
</script>
<style>
.wrapper-copy {
  position: relative;
}
.copy-btn {
  position: absolute;
  right: 0; 
  top: 0;
  margin-top: 10px;
  background-color: #fff;
}
</style>